import { useEffect } from "react";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { LEGAL } from "@lib/shop-utils";
import { getModalSettings } from "@lib/api/calls";
import { trackEvent } from "@lib/track-event";
import { getGlobalConfig } from "@lib/api/calls";
import { getLegalPage, getLegalPagesHandles } from "@lib/api/calls/getLegalPages";
import { Layout } from "@components/Layout/index";
import styles from "./page.module.css";

export default function Page({ preview, shop, config, subscribed, modal }) {
  const { query } = useRouter();
  const page = shop[LEGAL[query.page]];

  useEffect(() => {
    if (page) {
      trackEvent("view_page", {
        pageTitle: page.title,
        pageCategory: "Information Page",
        pageLocation: window.location.href,
        pagePath: window.location.pathname,
      });
    }
  }, [page]);

  const seo = {
    seoTitle: `${page?.title} | Kotn`,
    seoDescription: "",
    openGraphImage: null,
    twitterCard: "summary_large_image",
  };

  return (
    <Layout
      config={config}
      title={page?.title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      modal={modal}
      pageFound={page}
    >
      <section className={styles.section}>
        <h1>{page.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: page.body }} />
      </section>
    </Layout>
  );
}

export async function getStaticPaths({ locales }) {
  const shop = await getLegalPagesHandles();
  const paths = [];

  Object.keys(shop).forEach((key) => {
    if (shop[key].handle) {
      paths.push({
        params: { page: shop[key].handle },
      });

      locales.forEach((locale) => {
        if (locale !== "en") {
          paths.push({
            params: { page: shop[key].handle },
            locale,
          });
        }
      });
    }
  });

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params, locale, preview = false }) {
  const isFrench = locale === "fr";
  const data = await getLegalPage(LEGAL[params.page], isFrench);
  const modal = await getModalSettings(locale, preview);
  const config = await getGlobalConfig(locale, preview);

  return {
    props: {
      modal,
      config,
      ...data,
      ...(await serverSideTranslations(locale, [
        "common",
        "navbar",
        "footer",
        "cart",
        "recommendations",
      ])),
    },
    revalidate: 1800,
  };
}
